const isVideo = url => {
    if (!url) return false;
    return (
        url.match(
            /\.(mp4|m4a|m4v|f4v|f4a|m4b|m4r|f4b|mov|webm|flv|ogg|oga|ogv|ogx|wmv|wma|asf\*|3gp|3gp2|3g2|3gpp|3gpp2)(?=\?|$)/,
        ) !== null
    );
};

export default isVideo;
